<div class="ui-g">
  <p-toast ></p-toast>
  <div class="ui-g-4 ui-md-3 ui-lg-3"></div>
  <div class="cardGray ui-g-12 ui-md-6 ui-lg-6" style="padding: 2%;">
    <form class="form-group-login"  [formGroup]="userform" >
      <div class="ui-g-12">
        <div class="ui-g-12 ui-md-12 ui-sm-12" style="display: flex; align-items: center;">
          <img style="width: 100px; margin: 0 auto;" src="assets/images/register/otp.png" alt="">
        </div>
        <div class="ui-g-12 ui-md-12 ui-sm-12">
          <div lass="ui-g-12 ui-md-12 ui-sm-12" style="text-align: center;">
            <h2 class="title">Verificación SMS</h2>
          </div>
          <div class="ui-g-12 ui-md-12 ui-sm-12">
              <p class="subTitle">Ingresar el código OTP de 6 dígitos, enviado al número registrado.</p>
<!--              <h2 style="text-align: center; color: #073c8f;">50982719</h2>-->
          </div>
        </div>
        <div class="ui-g-12 ui-md-12 ui-lg-12" *ngIf="timer == 0">
          <div class="action">
            <a (click)="resendSms('1','2')"> Enviar otro SMS </a>
          </div>
          <div class="action">
            <a (click)="resendSms('2','2')">Enviar por correo </a>
          </div>
        </div>
        <div class="ui-g-12 ui-lg-12 ui-md-12" *ngIf="timer > 0">
          <div style="text-align: center; margin: 2%;">
            <a style="font-size: 16px;" (click)="resendSms('1','2')"> Espere {{timer}} segundos para volver a reenviar.</a>
          </div>
        </div>
      </div>
        <div class="ui-g-12">
          <div class="ui-g-2 ui-md-2 ui-lg-2">
            <input formControlName="n1" name="numberOtp" type="text" [(ngModel)]="n1"
              placeholder="-" disabled
                   oninput="javascript: this.value = this.value.replace(new RegExp('[^0-9]', 'gm'), '')"
              maxlength="1"
                   (keyup)="onDigitInput($event)"
              pInputText >
          </div>
          <div class="ui-g-2 ui-md-2" >
            <input formControlName="n2" name="numberOtp"  [(ngModel)]="n2" disabled
            placeholder="-"
            oninput="javascript: this.value = this.value.replace(new RegExp('[^0-9]', 'gm'), '')"
            maxlength="1"
                   (keyup)="onDigitInput($event)"
            pInputText >
          </div>
          <div class="ui-g-2 ui-md-2">
            <input formControlName="n3" name="numberOtp" [(ngModel)]="n3" disabled
            placeholder="-"
                   (keyup)="onDigitInput($event)"
            oninput="javascript: this.value = this.value.replace(new RegExp('[^0-9]', 'gm'), '')"
            maxlength="1"
            pInputText >
          </div>
          <div class="ui-g-2 ui-md-2 " >
            <input formControlName="n4" name="numberOtp" [(ngModel)]="n4" disabled
            placeholder="-"
                   (keyup)="onDigitInput($event)"
            oninput="javascript: this.value = this.value.replace(new RegExp('[^0-9]', 'gm'), '')"
            maxlength="1"
            pInputText >
          </div>
          <div class="ui-g-2 ui-md-2" >
            <input formControlName="n5" name="numberOtp" [(ngModel)]="n5" disabled
            placeholder="-"
                   (keyup)="onDigitInput($event)"
            oninput="javascript: this.value = this.value.replace(new RegExp('[^0-9]', 'gm'), '')"
            maxlength="1"
            pInputText >
          </div>
          <div class="ui-g-2 ui-md-2" >
            <input formControlName="n6" name="numberOtp" [(ngModel)]="n6" disabled
            placeholder="-"
                   (keyup)="onDigitInput($event)"
            oninput="javascript: this.value = this.value.replace(new RegExp('[^0-9]', 'gm'), '')"
            maxlength="1"
            pInputText >
          </div>
      </div>
      <div class="ui-g-12">
          <div class="ui-g-1 ui-md-1 ui-lg-2"></div>
          <div class="ui-g-12 ui-md-10 ui-lg-8 p-grid">
              <div class="ui-g-4 align">
                  <button pButton type="button" class="ui-button-primary ui-radiobutton-all btn" label="1" (click)="numberclicked(1)"></button>
              </div>
             <div class="ui-g-4 align">
                  <button pButton type="button" class="ui-button-primary ui-radiobutton-all btn" label="2" (click)="numberclicked(2)"></button>
             </div>
             <div class="ui-g-4 align">
                  <button pButton type="button" class="ui-button-primary ui-radiobutton-all btn" label="3"  (click)="numberclicked(3)"></button>
             </div>
              <div class="ui-g-4 align">
                  <button pButton type="button" class="ui-button-primary ui-radiobutton-all btn" label="4" (click)="numberclicked(4)"></button>
              </div>
              <div class="ui-g-4 align">
                  <button pButton type="button" class="ui-button-primary ui-radiobutton-all btn" label="5" (click)="numberclicked(5)"></button>
              </div>
              <div class="ui-g-4 align">
                  <button pButton type="button" class="ui-button-primary ui-radiobutton-all btn" label="6" (click)="numberclicked(6)"></button>
              </div>
               <div class="ui-g-4 align">
                  <button pButton type="button" class="ui-button-primary ui-radiobutton-all btn" label="7" (click)="numberclicked(7)"></button>
              </div>
              <div class="ui-g-4 align">
                  <button pButton type="button" class="ui-button-primary ui-radiobutton-all btn" label="8" (click)="numberclicked(8)"></button>
              </div>
              <div class="ui-g-4 align">
                  <button pButton type="button" class="ui-button-primary ui-radiobutton-all btn" label="9" (click)="numberclicked(9)"></button>
              </div>
              <div class="ui-g-4 align"></div>
              <div class="ui-g-4 align">
                  <button pButton type="button" class="ui-button-primary ui-radiobutton-all btn" label="0" (click)="numberclicked(0)"></button>
              </div>
              <div class="ui-g-4 align">
                  <button pButton type="button" class="ui-button-primary ui-radiobutton-all " icon="pi pi-chevron-left" style=" margin: 0 auto; width: 85px;height: 40px; "  (click)="numberclicked(-1)"></button>
              </div>
          </div>
          <div class="ui-g-1 ui-md-1 ui-lg-2"></div>
      </div>
      <div class="ui-g-12" style="margin-top: 2%;">
          <div class="ui-g-6">
              <button class="ui-button-success ui-widget ui-state-default" (click)="cancel()" pButton type="button" label="Regresar" style="width:100%;"></button>
          </div>
          <div class="ui-g-6"x>
              <button pButton type="button" class="ui-button-primary ui-widget ui-state-default" label="ACEPTAR" style="width:100%;" (click)="onSubmit()"></button>
          </div>
      </div>
    </form>
    <div class="progress-spinner" *ngIf="env.isContentLoading">
      <img src="assets/images/Logo-1.gif" alt="" width="300px">
    </div>
  </div>
  <div class="ui-g-4 ui-md-3 ui-lg-3"></div>
</div>
<!-- header class="rpn-header">
  <div class="rpn-header__heading">
    <a class="rpn-header__logo" href="/">
      <img class="rpn-logo--x" src="images/logo.png" alt="">
    </a>
    <a id="main-nav-trigger">
      <span></span>
      <span></span>
      <span></span>
    </a>
  </div>
  <a class="rpn-header__logo" href="/">
    <img class="rpn-logo" src="images/logo.png" alt="">
  </a>
  <div class="rpn-header__content">
    <div id="logoutBtn" class="rpn-uinf">
      <a class="rpn-logout-btn" href="/logout" >Salir <img src="images/ico-salir.png" alt=""></a>
    </div>
    <ul class="rpn-header__nav">
      <li class="rpn-header__nav--item">
        <a href="/profile">
          <img class="rpn-item-icon" src="images/nav/ico-perfil.png" alt="">
          Perfil
        </a>
      </li>
      <li class="rpn-header__nav--item">
        <a href="/providers">
          <img class="rpn-item-icon" src="images/nav/ico-proveedores.png" alt="">
          Proveedores
        </a>
      </li>
      <li class="rpn-header__nav--item">
        <a href="/authorization">
          <img class="rpn-item-icon" src="images/nav/ico-autorizaciones.png" alt="">
          Autorizaciones
        </a>
      </li>
      <li class="rpn-header__nav--item" style="display: none;">
        <a href="/forms">
          <img class="rpn-item-icon" src="images/nav/ico-formularios.png" alt="">
          Formularios
        </a>
      </li>
      <li class="rpn-header__nav--item">
        <a href="/coupons">
          <img class="rpn-item-icon" src="images/nav/ico-cupones.png" alt="">
          Cupones
        </a>
      </li>
      <li class="rpn-header__nav--item">
        <a href="/benefits">
          <img class="rpn-item-icon" src="images/nav/ico-star.png" alt="">
          Beneficios
        </a>
      </li>
    </ul>
  </div>
</header>
<div class="content-section implementation ui.fluid" id="mainContainer">
  <p-toolbar class="ui.fluid" >
    <div class="ui-toolbar-group-left">
      <button pButton type="button" icon="pi pi-question" class="ui-button-success"></button>
    </div>
    <div class="ui-toolbar-group-right">
      <button pButton type="button" icon="pi pi-question" class="ui-button-success"></button>
    </div>
    <div class="ui.fluid" style="display: flex;" >
      <img  class="logo" src='https://firebasestorage.googleapis.com/v0/b/atlantida-fc6a9.appspot.com/o/webImages%2Ficon_atlantida.png?alt=media&token=76271395-253a-477c-80b1-09054fc749bf'>
    </div>
  </p-toolbar>
  <form class="form-group-login"  [formGroup]="userform" (ngSubmit)="onSubmit(userform.value)">
    <p-toast ></p-toast>
    <h1  class="title-login" style="text-align: center;">REGISTRO</h1>
    <div class="ui-grid ui-grid-responsive ui-grid-pad ui-fluid" style="margin: 10px 0">
      <div class="ui-grid-row item-login">
        <div class="ui-grid-col-2">
            <input formControlName="n1" name="numberOtp" type="text"
                   placeholder="-"
                   oninput="javascript: this.value = this.value.replace(new RegExp('[^0-9]', 'gm'), '')"
                   maxlength="1"
                   pInputText >
        </div>
        <div class="ui-grid-col-2">
          <input formControlName="n2" name="numberOtp"
                 placeholder="-"
                 oninput="javascript: this.value = this.value.replace(new RegExp('[^0-9]', 'gm'), '')"
                 maxlength="1"
                 pInputText >
        </div>
        <div class="ui-grid-col-2">
          <input formControlName="n3" name="numberOtp"
                 placeholder="-"
                 oninput="javascript: this.value = this.value.replace(new RegExp('[^0-9]', 'gm'), '')"
                 maxlength="1"
                 pInputText >
        </div>
        <div class="ui-grid-col-2">
          <input formControlName="n4" name="numberOtp"
                 placeholder="-"
                 oninput="javascript: this.value = this.value.replace(new RegExp('[^0-9]', 'gm'), '')"
                 maxlength="1"
                 pInputText >
        </div>
        <div class="ui-grid-col-2">
          <input formControlName="n5" name="numberOtp"
                 placeholder="-"
                 oninput="javascript: this.value = this.value.replace(new RegExp('[^0-9]', 'gm'), '')"
                 maxlength="1"
                 pInputText >
        </div>
        <div class="ui-grid-col-2">
          <input formControlName="n6" name="numberOtp"
                 placeholder="-"
                 oninput="javascript: this.value = this.value.replace(new RegExp('[^0-9]', 'gm'), '')"
                 maxlength="1"
                 pInputText >
        </div>
      </div>
      <div class="ui-grid-row item-login">
        <div class="ui-grid-col-12">
          <button pButton type="submit" label={{loginBtnTitle}} [disabled]="!userform.valid"></button>
        </div>
      </div>
      <div style="text-align:center;margin-top:20px" *ngIf="submitted">
        Form Submitted
        <br>
      </div>
    </div>
  </form>
  <div class="ui-grid-col-12">
    <button pButton label={{loginBtnTitle}} (click)="setvalues()"></button>
  </div>
</div-->
